/**
 * Application Entry Point
 *
 * Purpose: Initialize React app with Redux, routing, and providers
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './app/store'
import { AppRouter } from './routes'
import { initCsrfProtection } from './security/csrf'
import './index.css'

// Initialize CSRF protection
initCsrfProtection()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <AppRouter />
      </PersistGate>
    </Provider>
  </React.StrictMode>
)
